export default () => {
  (function($) {
    $(document).ready(function() {
      var windowWidth = window.innerWidth
      if ($(window).width() < 992) {
        $('.footer__control button').removeClass('active')
        $('.footer__top').hide()
      } 
      $(window).on('resize', function() {
        if (window.innerWidth != windowWidth) {
          $('.footer__control button').removeClass('active')
          if ($(this).width() < 992) {
            $('.footer__top').hide()
          } else {
            $('.footer__top').show()
          }
          windowWidth = $(window).width();
        }
      })
    })

    $(document).ready(function() {
      $('.footer__control button').on('click', function() {
        $(this).toggleClass('active')
        $('.footer__top').toggle()
				let currentExpanded = ($(this).attr('aria-expanded') == 'true') ?　true : false
				$(this).attr('aria-expanded', !currentExpanded)
      })
    })
  })(window.hsvmJQuery)
}